import { useNestedQueryParamHelper } from '@shared/core/queryString';
import { useNestedStaysSearchParams } from '@apps/stays/components/SearchParamsObserver/SearchParamsObserver';
import { ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY } from './useAccommodationsConsoleSearchParamsState';

export const useAccommodationsConsoleSearchParamsHelper = () => {
  return useNestedQueryParamHelper(ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY);
};

export const useValidatedAccommodationsConsoleSearchParams = () => {
  return useNestedStaysSearchParams({ rootQueryParamKey: ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY });
};
